import { useTranslation } from "react-i18next";
import SymptomsTable from "./SymptomsTable";
import React, {useContext} from "react";
import InitContext from "../pages/InitContext";

const Symptoms = () => {
  const { t } = useTranslation();
  const context = useContext(InitContext);

  return (
    <div className="w3-display-container content-container content-container-full">
      <div className="medication-view">
        <div style={{ width: '100%', textAlign: 'right', paddingRight: "20px" }}>
          <label>{t("username")}: {context?.patient?.login}, {t("role")}: {t("patient").toLowerCase()}</label>
        </div>
        <div className="form-display-drugs medication-content">
          <div className="w3-panel w3-card-4 record-panel ">
            <SymptomsTable><h2>{t("symptoms")}</h2></SymptomsTable>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Symptoms;
